export default __webpack_public_path__ + "pdf/Rachel_Meyer.fed769e.pdf";